angular.module('picmonicng').factory('studyplansResource', [
  '$resource',
  function ($resource) {
    return $resource(
      '/api/v3/studyplans/:studyplan_id/:resource',
      { studyplan_id: '@studyplan_id', resource: '@resource' },
      {
        estimate: {
          method: 'POST',
          url: '/api/v3/studyplans/estimate',
          isArray: false,
        },
        ordered_list: {
          method: 'POST',
          url: '/api/v3/studyplans/ordered_list',
          isArray: true,
        },
        pathways: {
          method: 'GET',
          url: '/api/v3/studyplans/:studyplan_id/pathways',
          isArray: true,
        },
        survey: {
          method: 'POST',
          url: '/api/v3/studyplans/:studyplan_id/survey',
        },
        savePlan: { method: 'POST', url: '/api/v3/studyplans' },
        update: { method: 'PUT' },
      }
    );
  },
]);
